import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import { IBranch, IBranchesResult, ICity } from 'src/app/site/feature-modules/search-branch/models/branch.model';
import { GetBranches, SetSelectedBranch } from './branch.action';
import { ApiResponse } from '../../models/api-response.model';
import { ItemPlace } from 'src/app/site/shared-components/item-location-overlay/models/model';
import { branchUrl } from '../../defines/api.config';



export interface BranchStateModel {
    branches: IBranch[];
    cities: ICity[];
    filteredBranches: IBranch[];
    filteredCities: ICity[];
    selectedBranch: IBranch | null;
}

@State<BranchStateModel>({
    name: 'branch',
    defaults: {
        branches: [],
        cities: [],
        filteredBranches: [],
        filteredCities: [],
        selectedBranch: null,
    }
})
@Injectable()
export class BranchState {
    constructor(private http: HttpClient) { }

    // Selectors
    @Selector()
    static selectedBranch(state: BranchStateModel) {
        return state.selectedBranch;
    }


    @Selector()
    static branches(state: BranchStateModel) {
        return state.filteredBranches;
    }

    @Selector()
    static cities(state: BranchStateModel) {
        return state.filteredCities;
    }

    // Actions
    @Action(GetBranches)
    getBranches(ctx: StateContext<BranchStateModel>, action: GetBranches) {
        const state = ctx.getState();

        if (state.branches.length) {
            this.updateFilteredData(ctx, action.place);
            return of({ branches: state.branches, cities: state.cities });
        }

        return this.http.get<ApiResponse<IBranchesResult>>(branchUrl.getbranchList).pipe(
            tap((response) => {
                ctx.patchState({
                    branches: response.data.branches,
                    cities: response.data.cities
                });
                this.updateFilteredData(ctx, action.place);
            }),
            map((response) => response.data),
            catchError((error) => throwError(error))
        );
    }
    @Action(SetSelectedBranch)
    setSelectedBranch(ctx: StateContext<BranchStateModel>, action: SetSelectedBranch) {
        const state = ctx.getState();
        const branch = state.branches.find(b => b.id === action.branchId) || null;
        console.log('branch xxxxx',state);
        
        ctx.patchState({ selectedBranch: branch });
    }
    private updateFilteredData(ctx: StateContext<BranchStateModel>, place: ItemPlace) {
        const state = ctx.getState();
        const filteredBranches = state.branches.filter(
            (b) => b.place === place || b.place === ItemPlace.Both
        );
        const filteredCities = state.cities.filter((c) =>
            filteredBranches.some((b) => b.city.id === c.id)
        );

        ctx.patchState({
            filteredBranches,
            filteredCities
        });
    }
}
